export const flatListToHierarchical = (
  data = [],
  { idKey = "id", parentKey = "parent", childrenKey = "children" } = {}
) => {
  const tree = [];
  const childrenOf = {};

  data.forEach((item) => {
    const newItem = { ...item };
    const { [idKey]: id, [parentKey]: parentId = 0 } = newItem;

    childrenOf[id] = childrenOf[id] || [];
    newItem[childrenKey] = childrenOf[id];
    parentId
      ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
      : tree.push(newItem);
  });

  return tree;
};

export { normalizeUrl } from "../../utils/normalizeUrl";

export { default as MenuList } from "./MenuList";
